var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1054_6730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.414 128.554C175.344 116.008 156.839 115.872 152.194 100.478C143.811 72.7025 149.286 32.3613 108.959 38.7144C75.7523 43.9458 12.7877 26.1847 19.2393 66.9266C22.595 88.118 54.6357 100.575 56.1602 128.607C57.634 155.705 90.7989 163.329 118.753 163.336C146.741 163.342 187.517 150.187 181.414 128.554Z",
    fill: "#F0F5FE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1054_6730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3021 114.5L54.9532 142.059C54.8509 142.37 54.7937 142.694 54.7832 143.02C54.7626 146.678 58.8002 149.19 62.3021 147.5L142.366 106.905C147.537 104.283 147.461 96.8696 142.236 94.3544L59.5211 54.5358C55.978 52.8308 51.889 55.4142 52.0023 59.1394C52.0158 59.384 52.0556 59.6265 52.1208 59.8627L60.5779 93.6173C61.5913 97.6621 65.2265 100.499 69.3963 100.499H100",
    stroke: "url(#paint0_linear_1054_6730)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1054_6730",
    x1: 103.5,
    y1: 53.9995,
    x2: 103.5,
    y2: 147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5873FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#A28BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C58BFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1054_6730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1054_6730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.794,
    height: 122.794,
    fill: "white",
    transform: "translate(38.2285 45.0176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentIcon);
export default __webpack_public_path__ + "static/media/sent-icon.4870b1abf501b16e2a0abb963426d7e0.svg";
export { ForwardRef as ReactComponent };